export const css = {
    statusIcon: '_1mylMaad',
    badgeStatusIcon: '_1xOHzNDQ',
    statusNotDone: '_2_dkWhoQ',
    statusComplete: '_28QhuujT',
    statusInProgress: '_1R_-jTCM',
    ' _key': 'afcpe-theme/afcpe/book-widgets/status-icon'
};
export default css;
